<template>
  <VDialog :value="value" max-width="510" persistent @input="$emit('input', $event)">
    <VCard class="pa-4">
      <div class="heading-6 pb-4">{{ $t('nightRiderLink.expirationReminderTitle') }}</div>
      <p class="body-2 pb-4 mb-0">
        {{ $t('nightRiderLink.expirationReminderMessage', { date: formattedExpirationDate }) }}
      </p>
      <div
        class="pt-2 d-flex flex-row flex-nowrap align-stretch night-card-expiration-reminder-actions"
        style="width: 100%; column-gap: 8px;"
      >
        <div class="night-card-expiration-reminder-actions__cell">
          <VBtn
            class="w-100"
            outlined
            data-test="night-card-expiration-reminder-dismiss"
            @click="onDismiss"
          >
            <span class="button">{{ $t('nightRiderLink.expirationReminderDismiss') }}</span>
          </VBtn>
        </div>
        <div class="night-card-expiration-reminder-actions__cell">
          <VBtn
            class="w-100 text-decoration-none"
            color="brandingPrimary"
            data-test="night-card-expiration-reminder-go-settings"
            dark
            @click="goSettings"
          >
            <span class="button">{{ $t('nightRiderLink.expirationReminderGoToSettings') }}</span>
          </VBtn>
        </div>
      </div>
    </VCard>
  </VDialog>
</template>

<script lang="ts">
export default {
  name: 'SNightCardExpirationReminderDialog',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { formatNightCardExpirationDate } from '@slg/web-customer-shared/src/utils/nightCardExpirationLogic';
import { useI18n } from '../../composables';

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  expirationAt: {
    type: [String, Number],
    default: null,
  },
});

const emit = defineEmits(['dismiss', 'input', 'go-to-settings']);

const { locale } = useI18n();

const formattedExpirationDate = computed(() => (
  formatNightCardExpirationDate(props.expirationAt, locale.value)
));

function onDismiss() {
  emit('dismiss');
  emit('input', false);
}

function goSettings() {
  emit('go-to-settings');
  emit('input', false);
}
</script>

<style scoped>
.night-card-expiration-reminder-actions {
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  box-sizing: border-box;
}

.night-card-expiration-reminder-actions__cell {
  flex: 1 1 0;
  min-width: 0;
}

.night-card-expiration-reminder-actions .button {
  text-transform: uppercase;
}
</style>
